import React, { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

/** Private previews are requested only as they enter the viewport. */
export default function DashboardImage({ source, alt = "", className = "" }) {
  const image = useRef(null);
  const [visibleSource, setVisibleSource] = useState(null);
  const [loaded, setLoaded] = useState(null);
  const isPrivate = typeof source === "string" && source.startsWith("/my/farms/");
  useEffect(() => {
    if (!isPrivate) return;
    if (typeof IntersectionObserver === "undefined") { setVisibleSource(source); return; }
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) {
        setVisibleSource(source);
        observer.disconnect();
      }
    });
    observer.observe(image.current);
    return () => observer.disconnect();
  }, [source, isPrivate]);
  useEffect(() => {
    if (!isPrivate || visibleSource !== source) return;
    const controller = new AbortController();
    let objectUrl;
    api.get(source, { responseType: "blob", signal: controller.signal })
      .then(({ data }) => {
        if (controller.signal.aborted || !["image/jpeg", "image/png", "image/webp"].includes(data.type)) return;
        objectUrl = URL.createObjectURL(data);
        setLoaded({ source, url: objectUrl });
      })
      .catch(() => { if (!controller.signal.aborted) setLoaded(null); });
    return () => {
      controller.abort();
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [source, isPrivate, visibleSource]);
  const resolved = isPrivate ? (loaded?.source === source ? loaded.url : undefined) : source;
  return <img ref={image} src={resolved || undefined} alt={resolved ? alt : ""} className={className} loading="lazy" />;
}
